import { render } from "./ProjectSurveyArchive.vue?vue&type=template&id=3abab703&scoped=true"
import script from "./ProjectSurveyArchive.vue?vue&type=script&lang=js"
export * from "./ProjectSurveyArchive.vue?vue&type=script&lang=js"

import "./ProjectSurveyArchive.vue?vue&type=style&index=0&id=3abab703&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3abab703"]])

export default __exports__